module.exports = __webpack_public_path__ + "mysqlPostit.svg?f553d2907d7ce44aad36e3c75a454820";